import React from "react"

const MessageReactions = React.memo(({ reactions, styles, onClick }) => {
    if (!reactions?.length) return null

    const groupedReactions = reactions.reduce((grouped, reaction) => {
        if (!reaction?.text) return grouped

        const existing = grouped.find(item => item.text === reaction.text)
        if (existing) {
            existing.count += 1
            return grouped
        }

        grouped.push({ text: reaction.text, count: 1 })
        return grouped
    }, [])

    if (!groupedReactions.length) return null

    return (
        <button type="button" className={styles.reactions} onClick={onClick} title="Ver reações">
            {groupedReactions.slice(0, 4).map((reaction) => (
                <span key={reaction.text}>
                    <b>{reaction.text}</b>
                    {reaction.count > 1 && <small>{reaction.count}</small>}
                </span>
            ))}
            {groupedReactions.length > 4 && <em>+{groupedReactions.length - 4}</em>}
        </button>
    )
})

export default MessageReactions
